<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :breadcrumbs="breadcrumbs"
        :title="page"
        icon="mdi-tag-multiple"
    ></vuse-section-definition>
    <v-container class=" p-5" fluid>
      <v-row class="white rounded-xl mx-1">
        <v-col cols="12">
          <v-row>
            <v-col cols="6">
              <v-col cols="12">
                <v-text-field
                    v-model="tag.name"
                    filled
                    label="Tên tag"
                    placeholder="Nhập tên tag"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                    v-model="tag.description"
                    filled
                    label="Mô tả"
                    placeholder="Nhập mô tả"
                ></v-text-field>
              </v-col>
             <v-col cols="12" class="text-center">
               <v-btn
                   color="primary"
                   width="180"
                   @click="save()"
               >
                 Lưu
               </v-btn>
             </v-col>

            </v-col>
            <v-col cols="6">
              <v-col cols="12">
                <h3 class="font-weight-medium mb-3">Chọn màu</h3>
                <vue-gpickr v-model="gradient" class="mb-10" />
                <v-text-field v-model="gradient" outlined readonly class="show_color"></v-text-field>
              </v-col>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import {VueGpickr, LinearGradient} from 'vue-gpickr';
import {SAVE_TAG} from "@/store/modules/tags";
export default {
  name: "AddNewTags",
  components: {
    VueGpickr
  },
  data() {
    const gradient = new LinearGradient({
      angle: 180,
      stops: [
        ['#1CC692', 0],
        ['#2A475D', 1]
      ]
    });
    return {
      page: "Thêm Tag",
      gradient,
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true,
        },
        {
          text: "Danh sách tags",
          disabled: true,
        },
        {
          text: "Thêm tag",
          disabled: false,
        },
      ],
      tag: {
        name: '',
        description: '',
      }
    }
  },
  methods:{
    async save() {
      let data = {
        name: this.tag.name,
        description: this.tag.description,
        color: this.gradient.toString(),
        object_tag: JSON.stringify(this.gradient.toRaw(), null, "  ")
      }
      await this.$store.dispatch(`${SAVE_TAG}`, data).then((data) => {
        if (data.data.status == 1) {
          this.$toasted.success('Cập nhật thành công!', {
            duration: 1000,
            position: 'top-center'
          })
          this.$router.push('/project_management/tags')
        }
        else {
          alert(data.data.errors)
        }
      });
    }
  }
}
</script>

<style scoped>
.show_color{
  width: 70%;
}
</style>